import { useInView } from "@/lib/anim";

const C = { x: 290, y: 290 };
const R = 228;

const LABELS = [
  "Banks",
  "KYC / eKYC",
  "Payment Gateways",
  "Cards",
  "FX",
  "Fraud & Risk",
  "Wallets",
  "Banking Systems",
  "Notifications",
];

export default function ConnectorsNetwork() {
  const [ref, inView] = useInView({ threshold: 0.25 });
  const nodes = LABELS.map((label, i) => {
    const angle = (-90 + i * 40) * (Math.PI / 180);
    return {
      label,
      x: C.x + R * Math.cos(angle),
      y: C.y + R * Math.sin(angle),
      accent: i % 2 === 0 ? "#2563EB" : "#0EA5A4",
    };
  });

  return (
    <div ref={ref} className={`eco-viz ${inView ? "is-visible" : ""}`}>
      <svg
        data-testid="connectors-network-visual"
        viewBox="0 0 580 580"
        className="mx-auto h-auto w-full max-w-[520px]"
        role="img"
        aria-label="iJeeva integration network connecting banks, KYC services, payment gateways, cards, FX, fraud and risk systems, wallets, banking systems and notifications"
      >
        <defs>
          <filter id="cnShadow" x="-40%" y="-40%" width="180%" height="180%">
            <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#0F172A" floodOpacity="0.08" />
          </filter>
          <filter id="cnHubShadow" x="-60%" y="-60%" width="220%" height="220%">
            <feDropShadow dx="0" dy="10" stdDeviation="22" floodColor="#1D305B" floodOpacity="0.25" />
          </filter>
        </defs>

        <circle cx={C.x} cy={C.y} r={R} fill="none" stroke="#E2E8F0" strokeWidth="1" strokeDasharray="2 8" className="flow-dash-slow" />
        <circle cx={C.x} cy={C.y} r="120" fill="none" stroke="#E2E8F0" strokeWidth="1" strokeDasharray="2 8" className="flow-dash-slow" />

        {nodes.map((n, i) => (
          <line
            key={`l-${n.label}`}
            x1={C.x}
            y1={C.y}
            x2={n.x}
            y2={n.y}
            stroke={n.accent}
            strokeWidth="1.3"
            strokeDasharray="3 9"
            opacity="0.5"
            className="viz-link"
            style={{ transitionDelay: `${i * 80}ms` }}
          />
        ))}

        {nodes.map((n, i) => (
          <circle key={`d-${n.label}`} r="3.2" fill={n.accent} opacity="0.9">
            <animateMotion
              dur={`${6.5 + (i % 3) * 1.6}s`}
              begin={`${i * 0.6}s`}
              repeatCount="indefinite"
              path={`M ${C.x} ${C.y} L ${n.x} ${n.y}`}
              keyPoints={i % 2 === 0 ? "0;1" : "1;0"}
              keyTimes="0;1"
              calcMode="linear"
            />
          </circle>
        ))}

        {nodes.map((n, i) => {
          const w = 144;
          return (
            <g key={n.label} className="viz-node" style={{ transitionDelay: `${100 + i * 70}ms` }} filter="url(#cnShadow)">
              <rect x={n.x - w / 2} y={n.y - 18} width={w} height="36" rx="9" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.2" />
              <circle cx={n.x - w / 2 + 15} cy={n.y} r="2.8" fill={n.accent} />
              <text x={n.x - w / 2 + 24} y={n.y + 4} fontSize="11.5" fontWeight="500" fill="#1D305B" fontFamily="Inter, sans-serif">
                {n.label}
              </text>
            </g>
          );
        })}

        <g filter="url(#cnHubShadow)">
          <circle cx={C.x} cy={C.y} r="58" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.2" />
          <image href="/logo.png" x={C.x - 42} y={C.y - 18} width="84" height="36" preserveAspectRatio="xMidYMid meet" />
        </g>
      </svg>
    </div>
  );
}
